import { z } from 'zod'
import {
  EntityItemArrayOptionalSchema,
  EntityItemArraySchema,
  EntityItemSchema,
  OptionalNumberSchema,
  OptionalStringSchema,
  OrganizationSchema,
  YYYYMMDDRegexOptionalSchema,
  YYYYMMDDRegexSchema,
  OptionalAddressSchema,
  LinkedPeopleOptionalSchema,
  QueueJoinOptionalSchema,
  DocumentRecordSchema,
  OrganizationItemSchema,
  LinkedPeopleSchema,
  QueueJoinSchema,
  OptionalCoordinateSchema,
  LocationItemArraySchema,
  TotalsSchema,
} from './entity'

export enum PublishStatus {
  NeedsReview = 'Needs Review',
  Spiked = 'Spiked',
  Published = 'Published',
  ApprovedToPublish = 'Approved to Publish',
  Draft = 'Draft',
  Hold = 'HOLD',
}

export const SignalSchema = z.object({
  id: z.string(),
  state: EntityItemArraySchema,
  country: EntityItemArrayOptionalSchema,
  county: EntityItemArrayOptionalSchema,
  sectors: EntityItemArraySchema,
  queueApplications: QueueJoinOptionalSchema,
  projectPipeline: EntityItemArrayOptionalSchema,
  headline: z.string().min(1),
  body: OptionalStringSchema,
  filingDate: YYYYMMDDRegexOptionalSchema,
  publishedDate: YYYYMMDDRegexOptionalSchema,
  commercialOperationDate: YYYYMMDDRegexOptionalSchema,
  facilityName: OptionalStringSchema,
  facilityAddress: OptionalAddressSchema,
  location: LocationItemArraySchema,
  geo: z.object({
    default: OptionalCoordinateSchema,
    defaultValue: OptionalStringSchema,
    location: OptionalCoordinateSchema,
    facility: OptionalCoordinateSchema,
    county: OptionalCoordinateSchema,
  }),
  organizations: OrganizationSchema,
  keyPeople: LinkedPeopleOptionalSchema,
  documents: DocumentRecordSchema,
  mw: OptionalNumberSchema,
  pucTracker: EntityItemArrayOptionalSchema,
  editorNotes: OptionalStringSchema,
  analystNotes: OptionalStringSchema,
  createdBy: EntityItemArraySchema,
  created: YYYYMMDDRegexSchema,
  status: z.nativeEnum(PublishStatus),
  curateDocLink: z.string().url().optional(),
  curateMunicipalityLink: z.string().url().optional(),
  type: EntityItemSchema.optional(),
  subType: EntityItemArrayOptionalSchema,
  audiences: EntityItemArraySchema,
  lastUpdatedBy: EntityItemArraySchema,
  phase: OptionalStringSchema,
  dgChannels: EntityItemArrayOptionalSchema,
  projects: EntityItemArrayOptionalSchema,
  countyBoard: EntityItemArrayOptionalSchema,
  schoolDistrict: EntityItemArrayOptionalSchema,
  totals: TotalsSchema,
  allSectors: OptionalStringSchema,
  $organizations: z.string().optional(), // this could be an empty string
})

export type Signal = z.infer<typeof SignalSchema>
export type OrganizationItem = z.infer<typeof OrganizationItemSchema>
export type DocumentRecord = z.infer<typeof DocumentRecordSchema>
export type LinkedPersonItem = z.infer<typeof LinkedPeopleSchema>[number]
export type QueueJoinItem = z.infer<typeof QueueJoinSchema>[number]
export type ProjectItem =
  z.infer<typeof EntityItemArrayOptionalSchema> extends Array<infer T>
    ? T
    : never
